<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.countryDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.countryDetailsInfo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.title.$invalid && $v.title.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="title"
                      />
                      <form-error :model="$v.title" :dirty="$v.$dirty" label="Naziv"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.abbreviation.$invalid && $v.abbreviation.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Skraćenica</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Skraćenica"
                        v-model="abbreviation"
                      />
                      <form-error :model="$v.abbreviation" :dirty="$v.$dirty" label="Skraćenica"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.dialingCode.$invalid && $v.dialingCode.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Pozivni broj</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Pozivni broj"
                        v-model="dialingCode"
                      />
                      <form-error :model="$v.dialingCode" :dirty="$v.$dirty" label="Pozivni broj"/>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Countries' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
        <!-- <div class="col-12 col-md-auto ms-md-auto mt-3 mt-md-0 ms-auto">
          <a href="#" class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> Delete Category
          </a>
        </div> -->
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddCountry',
  mixins: [translations],
  validations,
  components: { FormError },
  data() {
    return {
      title: '',
      abbreviation: '',
      dialingCode: ''
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const { title, dialingCode, abbreviation } = this;

      api.createCountry({dialingCode, abbreviation, title })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Countries' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
};
</script>